import { del, set, useAuth } from "@warden-ui/common";
import { parseQueryString, parseAmplifyConfig } from "@warden-ui/common";
import { useSearchParams, useNavigate} from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { CPPageBody } from "@warden-ui/common-components";
import { CardContentError } from "@warden-ui/common-components";

const defaultQueryString: {[key: string]: string} = {
  team_domain: "",
  region: "",
  config: "",
  identity_provider: "",
  clear: "true",
}

export default function FederatedSignIn() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState("");

  searchParams.set("clear", "false"); // redirect page should not be cleared to avoid infinite loop
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = useMemo(() => parseAmplifyConfig(queryString), [queryString]);

  useEffect(() => {
    auth.configureAmplify(amplifyConfig);
  }, [auth, amplifyConfig]);

  useEffect(() => {
    const identityProvider = queryString.identity_provider;
    console.log("[federated] sign in with", identityProvider);
    set("identity_provider", identityProvider);

    auth.federatedSignIn(identityProvider, amplifyConfig)
    .catch((error) => {
      setErrorMessage(error.message);
      del('identity_provider');
    });
  }, []);

  if (auth.isSignedIn) {
    navigate(`/redirect?${searchParams.toString()}`);
  }

  if (errorMessage) {
    return (
      <CPPageBody>
        <CardContentError
          message={errorMessage}
        />
      </CPPageBody>
    );
  }

  // TODO: show waiting page
  return null;
}
